import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getFaq, destroyFaq, changeActiveStatus, updateFaq } from './faqSlice';
import { Container, Modal, Toast, Button } from "react-bootstrap";
import Input from "../../components/input";
import { useNavigate, useLocation } from "react-router-dom";
import CommonButton from "../../components/commonButton";
import CommonPagination from "../../components/commonPagination";
import CommonTable from '../../components/commonTable';
import { Add01Icon } from "../../assets/icons";
import { useLoader } from "../../context/LoaderContext";
// import CategoryView from './CategoryView';

const FaqList = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { setLoading } = useLoader();
  const { faqs } = useSelector((state) => state.faqs);
  console.log("faqs", faqs);
  
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategoryId, setSelectedCategoryId] = useState('');
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarVariant, setSnackbarVariant] = useState("success");
  const limit = 10;
  const totalPages = Math.ceil(faqs?.total_records / limit);
  const total = faqs?.total_records || 0;

  const location = useLocation();
  const params = new URLSearchParams(location.search) || 1;
  const initialPage = parseInt(params.get("page") || "1");
  const [currentPage, setCurrentPage] = useState(initialPage);

  const token = localStorage.getItem('auth-token');

  let categoryMessage = localStorage.getItem('faq_notify_message');

  useEffect(() => {
    if (categoryMessage) {
      setSnackbarMessage(categoryMessage);
      setSnackbarVariant("success");
      setShowSnackbar(true);
      localStorage.removeItem('faq_notify_message');
    }
  }, [categoryMessage])

  useEffect(() => {
    const fetchFaq = async () => {
      setLoading(true);
      const payload = {
        page: currentPage,
        search: searchTerm,
        limit: limit,
        token,
        order_by: 'sequence',
        order: 'asc'
      };
  
      try {
        if (token) {          
          await dispatch(getFaq(payload));
        }
      } catch (error) {
        setLoading(false);
        console.error("Error fetching faqs:", error);
      } finally {
        setLoading(false);
      }
    };
  
    fetchFaq();
  }, [dispatch, token, currentPage, searchTerm, setLoading]);
  

  const columns = [
    // { label: 'ID', key: 'id' },
    { label: 'Question', key: 'question' },
    { label: 'created at', key: 'created_at', type: 'date' },
    {label: 'Status', key: 'is_active', type: 'status' },
  ];

  const handlePageChange = (newPageNumber) => {
    setCurrentPage(newPageNumber);
    navigate(`/faqs?page=${newPageNumber}`);
  };

  const handleDeleteNew = async () => {
    if (selectedCategoryId) {
      await dispatch(destroyFaq(selectedCategoryId)).then((res) => {
        if(res.payload.success) {
          setShowDeleteModal(false);
          setSnackbarMessage(res.payload.message);
          setSnackbarVariant("success");
          setShowSnackbar(true);
          const payload = {
            page: currentPage,
            search: searchTerm,
            limit: limit,
            token,
            order_by: 'sequence',
            order: 'asc'
          };
          dispatch(getFaq(payload));
        } else {
          setShowDeleteModal(false);
          setSnackbarMessage(res.payload.message);
          setSnackbarVariant("danger");
          setShowSnackbar(true);
        }
      });
    }
  };

  const handleEdit = (row) => {
    // setSelectedCategoryId(row.id);
    navigate(`/faq-edit/${row.id}?page=${currentPage}`);
    // handleOpen();
  };

  // const handleOpen = () => {
  //   setTimeout(() => {
  //     setShowEditModal(true);
  //   }, 1000);
  // };
  

  const handleDelete = (row) => {
    setSelectedCategoryId(row.id);
    setShowDeleteModal(true);
  };

  const handleView = (row) => {
    setSelectedCategoryId(row.id);
  };

  const handleStatusChange = async (row) => {
    setSelectedCategoryId(row.id);
    setShowStatusModal(true);
  }

  const handleStatusChangeNew = async () => {
    await dispatch(changeActiveStatus(selectedCategoryId)).then((res) => {
      if(res.payload.success) {
        setShowStatusModal(false);
        setSnackbarMessage(res.payload.message);
        setSnackbarVariant("success");
        setShowSnackbar(true);
        const payload = {
          page: currentPage,
          search: searchTerm,
          limit: limit,
          token,
          order_by: 'sequence',
          order: 'asc'
        };
        dispatch(getFaq(payload));
      } else {
        setShowStatusModal(false);
        setSnackbarMessage(res.payload.message);
        setSnackbarVariant("danger");
        setShowSnackbar(true);
      }
    });
  }

  useEffect(() => {
    if (initialPage) {
      setCurrentPage(initialPage);
    }     
  }, [initialPage])
  
  return (
    <>
      <Container fluid className="px-0">
        <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Confirm Delete</Modal.Title>
          </Modal.Header>
          <Modal.Body>Are you sure you want to delete this FAQ?</Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
              Cancel
            </Button>
            <Button variant="danger" onClick={handleDeleteNew}>
              Delete
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal show={showStatusModal} onHide={() => setShowStatusModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Confirm Status Update</Modal.Title>
          </Modal.Header>
          <Modal.Body>Are you sure you want to change status?</Modal.Body>
          {/* <Modal.Body><span className='text-danger'>Warning:- Deactivating category may impact on website.</span></Modal.Body> */}
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowStatusModal(false)}>
              Cancel
            </Button>
            <Button variant="primary" onClick={handleStatusChangeNew}>
              Change
            </Button>
          </Modal.Footer>
        </Modal>

        <Toast
          onClose={() => setShowSnackbar(false)}
          show={showSnackbar}
          delay={3000}
          autohide
          bg={snackbarVariant}
          style={{ position: "fixed", top: 20, right: 20, zIndex: 1000 }}
        >
          <Toast.Body style={{ color: "white" }}>{snackbarMessage}</Toast.Body>
        </Toast>

        <div className="p-4 d-flex align-items-center justify-content-between gap-4">
          <Input
            type="search"
            value={searchTerm}
            placeholder="Search FAQ"
            onChange={(e) => {
              setSearchTerm(e.target.value);
              setCurrentPage(1);
              navigate(`/faqs?page=1`);
            }}
            className="shadow-none base-search"
          />

          <CommonButton
            icon={<Add01Icon width={16} height={16} color="#ffffff" strokeWidth="2" />}
            title="Add FAQ"
            className="btn-primary common-one-shadow"
            onClick={() => {
              navigate(`/faq-add?page=${currentPage}`);
            }}
          />
        </div>

        <div className="bg-white rounded-2 overflow-hidden common-shadow">
            <CommonTable
              columns={columns}
              data={Array.isArray(faqs?.data) ? faqs.data : []}
              url={faqs?.url || []}
              showActions={true}
              moduleName="faq"
              actions={{
                showEdit: true,
                showDelete: true,
                showView: false,
                onEdit: handleEdit,
                onDelete: handleDelete,
                onView: handleView
              }}
              onStatusChange={handleStatusChange}
              draggable={true} 
              onDragEnd={async (updatedFaqs) => {
                console.log("Updated FAQs:", updatedFaqs);
              
                for (const item of updatedFaqs) {
                  const formData = new FormData();
                  formData.append('id', item.id);
                  formData.append('question', item.question);
                  formData.append('answer', item.answer);
                  formData.append('sequence', item.sequence);
                  formData.append('_method', 'PUT'); 
              
                  await dispatch(updateFaq(formData));
                }
              

                dispatch(getFaq({
                  page: currentPage,
                  search: searchTerm,
                  limit: limit,
                  token,
                  order_by: 'sequence',
                  order: 'asc'
                }));
              }}
            />
        </div>
        <div className="p-3 mx-1 d-flex flex-wrap align-items-center justify-content-between gap-4">
          <p className="custom-table-infotext">
            Displaying {(limit * (currentPage - 1)) + 1} to {Math.min(limit * currentPage, total)} of {total} FAQs
          </p>

          <div>
            {totalPages > 1 ? (
              <CommonPagination
                totalItems={total}
                itemsPerPage={limit}
                currentPage={currentPage}
                onPageChange={handlePageChange}
              />
            ) : null}
          </div>
        </div>
      </Container>
    </>
  );
};

export default FaqList;
